import { render, staticRenderFns } from "./radio-table.vue?vue&type=template&id=fedee928&"
import script from "./radio-table.vue?vue&type=script&lang=js&"
export * from "./radio-table.vue?vue&type=script&lang=js&"
import style0 from "./radio-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "radio-table.vue"
export default component.exports